const Spinner = ({ loading }) => {
    return (
        <div
            className={`fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 transition-opacity duration-200 ease-in-out ${loading ? 'opacity-50 pointer-events-auto' : 'opacity-0 pointer-events-none'
                }`}
        >
            <div className="flex items-center">
                <div className="w-10 h-10 border-4 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
                <span className="ml-4 text-white">Loading...</span>
            </div>
        </div>
    );
};

export default Spinner;